import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import Logo from '../images/Decad3Logo.webp';

const socialLinks = [
    { href: "https://www.facebook.com/profile.php?id=100071854380014", label: "Facebook", Icon: FacebookIcon },
    { href: "https://twitter.com/wb4gbi", label: "Twitter", Icon: TwitterIcon },
    { href: "https://www.instagram.com/hamradiowb4gbi/", label: "Instagram", Icon: InstagramIcon },
];

const siteLinks = [
    { to: "/", label: "Home" },
    { to: "/gallery", label: "Gallery" },
    { to: "/documents", label: "Documents" },
    { to: "/about", label: "About" },
];

const Footer = ({ districts }) => {
    return (
        <Box component="footer" sx={{ mt: 8, pt: 4, pb: 4 }}>
            <Container maxWidth="lg" sx={{ textAlign: 'center' }}>
                <Divider sx={{ mb: 3 }} />
                <Stack direction="row" spacing={1} justifyContent="center" sx={{ mb: 4 }}>
                    {socialLinks.map(({ href, label, Icon }) => (
                        <IconButton key={href} component="a" href={href} target="_blank" rel="noreferrer" aria-label={label} color="inherit">
                            <Icon />
                        </IconButton>
                    ))}
                </Stack>

                <Grid container spacing={4}>
                    <Grid size={{ xs: 12, sm: 4 }}>
                        <Typography variant="h6" gutterBottom>Site Links</Typography>
                        <Stack spacing={1}>
                            {siteLinks.map(({ to, label }) => (
                                <Link key={to} component={RouterLink} to={to} underline="hover" color="inherit">
                                    {label}
                                </Link>
                            ))}
                        </Stack>
                    </Grid>

                    <Grid size={{ xs: 12, sm: 4 }}>
                        <Typography variant="h6" gutterBottom>Repeaters</Typography>
                        <Stack direction="row" flexWrap="wrap" justifyContent="center" spacing={1.5} useFlexGap>
                            {districts.map((d) => (
                                <Link key={d._id} component={RouterLink} to={`/repeater/${d.district}`} underline="hover" color="inherit">
                                    {d.district}
                                </Link>
                            ))}
                        </Stack>
                    </Grid>

                    <Grid size={{ xs: 12, sm: 4 }}>
                        <Typography variant="h6" gutterBottom>Other Links</Typography>
                        <Link href="https://etskywarn.com" target="_blank" rel="noreferrer" underline="hover" color="inherit">
                            ET SKYWARN
                        </Link>
                    </Grid>
                </Grid>

                <Box sx={{ textAlign: 'center', mt: 4 }}>
                    <Typography variant="body2" color="text.secondary">©2023 WB4GBI</Typography>
                    <Link href="https://decad3.com" sx={{ display: 'inline-block', mt: 1 }}>
                        <Box component="img" src={Logo} alt="Decad3 Logo" sx={{ width: 200, height: 'auto' }} />
                    </Link>
                </Box>
            </Container>
        </Box>
    );
};

export default Footer;
